<template>
	<div class="shareppl-parentdiv">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="headtext d-flex align-items-center justify-content-between">
			<div class="d-flex">
				<img
					src="../../assets/icons/Reports/bckarrow.svg"
					alt=""
					class="pointer"
					@click="goToGroupShare()"
				/>
				<div class="heading ml-3">
					<span>Configure</span>
				</div>
			</div>
			<div
				class="d-flex relativeclass"
				v-if="roles.includes(roledata.addconfig)"
			>
				<b-button class="addbtn mr-2" @click="addConfiguration()">
					<img
						src="../../assets/icons/Reports/addIndividual.svg"
						alt=""
						class="mr-2 mb-1"
					/>
					<span class="">Add Configuration</span>
				</b-button>
			</div>
		</div>
		<!-- selected Configuration -->

		<div v-if="dataLoaded">
			<div
				class="mt-3"
				v-if="
					selectedConfiguration != null &&
						Object.keys(selectedConfiguration).length != 0
				"
			>
				<div class="relativeclass">
					<div class="select-config-head">
						<div class="select-config-head-font">Selected Configuration</div>
					</div>
					<div class="d-flex select-configurations">
						<div style="width: 90%" class="d-flex align-items-center">
							<div class="config-dynamicGrid mr-1"></div>
							<div style="width: 30%" class="ml-4">
								<div class="select-configurations-head">Configuration Name</div>
								<div
									v-b-popover.hover.bottom="selectedConfiguration.configName"
									class="select-configurations-subhead mr-5 text-truncate"
								>
									{{ selectedConfiguration.configName }}
								</div>
							</div>
							<div style="width: 30%">
								<div class="select-configurations-head">Tagged to</div>
								<div class="select-configurations-subhead">
									<span v-if="selectedConfiguration.groupNames.length > 0">
										<span
											v-if="selectedConfiguration.groupNames[0].length > 40"
										>
											{{
												selectedConfiguration.groupNames[0]
													.toString()
													.slice(0, 39) + `...`
											}}
										</span>
										<span v-else>
											{{ selectedConfiguration.groupNames[0] }}
										</span>

										<span v-if="selectedConfiguration.groupNames.length > 1">
											and
											{{ selectedConfiguration.groupNames.length - 1 }}
											others</span
										>
									</span>
									<!-- {{ selectedConfiguration.groupIDs[0].toString() + ' and '+ `${selectedConfiguration.groupIDs.length}` + " others" }} -->
								</div>
							</div>
							<div style="width: 25%">
								<div class="select-configurations-head">Start Date</div>
								<div class="select-configurations-subhead">
									{{ selectedConfiguration.config.openTestdt | datefilter }}
								</div>
							</div>
							<div style="width: 10%">
								<div class="select-configurations-head">End Date</div>
								<div class="select-configurations-subhead">
									{{ selectedConfiguration.config.closeTestdt | datefilter }}
								</div>
							</div>
						</div>

						<div
							style="width: 10%"
							class="d-flex align-items-center justify-content-center"
						>
							<img
								class="pointer"
								src="../../assets/eyeicon.svg"
								v-b-tooltip.hover="{ variant: 'secondary' }"
								title="View"
								alt=""
								@click="viewConfig(selectedConfiguration)"
							/>
							<img
								v-if="roles.includes(roledata.editconfig)"
								@click="editConfig(selectedConfiguration)"
								class="ml-3 pointer"
								src="../../assets/pencilicon.svg"
								alt=""
								v-b-tooltip.hover="{ variant: 'secondary' }"
								title="Edit"
							/>
						</div>
					</div>
				</div>
			</div>

			<!-- table new design starts from here -->
			<div
				class="relativeclass mt-3"
				:class="
					grpcontainer
						? 'noSelectedConfiguration-main-table'
						: selectedConfiguration != null
						? 'newconfiguration-main-table'
						: 'newSelected-main-table'
				"
			>
				<div class="newconfiguration-table-head">
					<div style="width: 20%">
						<span style="margin-left: 20px">Name</span>
						<template v-if="sortColumn == 'configName'">
							<img
								@click="sort('configName'), (sorting = !sorting)"
								v-if="sorting == true"
								src="../../assets/ascending1.svg"
								alt=""
								class="pointer"
							/>
							<img
								v-else
								@click="sort('configName'), (sorting = !sorting)"
								src="../../assets/icons/share/descending.svg"
								alt=""
								class="pointer"
							/>
						</template>
						<img
							v-else
							@click="sort('configName'), (sorting = !sorting)"
							src="../../assets/icons/share/nosort.svg"
							alt=""
							class="pointer"
						/>
					</div>
					<div style="width: 30%" class="text-center">
						<span>Tagged To</span>
					</div>
					<div style="width: 10%" class="text-center">
						<span
							>Start Date
							<template v-if="sortColumn == 'openTestdt'">
								<img
									@click="sort('openTestdt'), (sorting = !sorting)"
									v-if="sorting == true"
									src="../../assets/ascending1.svg"
									alt=""
									class="pointer"
								/>
								<img
									v-else
									@click="sort('openTestdt'), (sorting = !sorting)"
									src="../../assets/icons/share/descending.svg"
									alt=""
									class="pointer"
								/>
							</template>
							<img
								v-else
								@click="sort('openTestdt'), (sorting = !sorting)"
								src="../../assets/icons/share/nosort.svg"
								alt=""
								class="pointer"
							/>
						</span>
					</div>
					<div style="width: 10%" class="text-center">
						<span
							>End Date
							<template v-if="sortColumn == 'closeTestdt'">
								<img
									@click="sort('closeTestdt'), (sorting = !sorting)"
									v-if="sorting == true"
									src="../../assets/ascending1.svg"
									alt=""
									class="pointer"
								/>
								<img
									v-else
									@click="sort('closeTestdt'), (sorting = !sorting)"
									src="../../assets/icons/share/descending.svg"
									alt=""
									class="pointer"
								/>
							</template>
							<img
								v-else
								@click="sort('closeTestdt'), (sorting = !sorting)"
								src="../../assets/icons/share/nosort.svg"
								alt=""
								class="pointer"
							/>
						</span>
					</div>
					<div style="width: 10%" class="text-center">
						<span class="mr-1"> Test Type</span>
						<template v-if="sortColumn == 'testType'">
							<img
								@click="sort('testType'), (sorting = !sorting)"
								v-if="sorting == true"
								src="../../assets/ascending1.svg"
								alt=""
								class="pointer"
							/>
							<img
								v-else
								@click="sort('testType'), (sorting = !sorting)"
								src="../../assets/icons/share/descending.svg"
								alt=""
								class="pointer"
							/>
						</template>
						<img
							v-else
							@click="sort('testType'), (sorting = !sorting)"
							src="../../assets/icons/share/nosort.svg"
							alt=""
							class="pointer"
						/>
					</div>
					<div style="width: 10%" class="text-center">
						<span class="mr-1">Status</span>
						<template v-if="sortColumn == 'open'">
							<img
								@click="sort('open'), (sorting = !sorting)"
								v-if="sorting == true"
								src="../../assets/ascending1.svg"
								alt=""
								class="pointer"
							/>
							<img
								v-else
								@click="sort('open'), (sorting = !sorting)"
								src="../../assets/icons/share/descending.svg"
								alt=""
								class="pointer"
							/>
						</template>
						<img
							v-else
							@click="sort('open'), (sorting = !sorting)"
							src="../../assets/icons/share/nosort.svg"
							alt=""
							class="pointer"
						/>
					</div>
					<div
						ref="rec"
						style="width: 10%"
						class="text-right position-relative"
					>
						<span @click="openfilter">
							<img
								src="../../assets/whitefilter.svg"
								alt=""
								class="mr-4 pointer"
							/>
						</span>
						<div class="qb-filter-count-config pb-3" v-if="filtercount != 0">
							<span class="mr-3 mb-2"> {{ filtercount }}</span>
						</div>
						<div
							id="filtermodal"
							ref="recdropdown"
							v-if="showfilter"
							class="sharepeople-filter-modal-config"
							v-closable="{
								exclude: ['rec', 'recdropdown'],
								handler: 'hideDropdown',
							}"
						>
							<div class="qb-fm-heading p-2 d-flex justify-content-start">
								<div @click="closefilter()" class="xMarkCancel pointer">
									<img src="../../assets/xmark.svg" alt="" />
								</div>
								Filter By
							</div>

							<div class="topicfilterinnercard m-2">
								<div class="d-flex configMoreData">
									<b-form-radio-group
										:options="filteroptions"
										v-model="filterselected"
										value-field="item"
										text-field="name"
										disabled-field="notEnabled"
										size="sm"
									></b-form-radio-group>
								</div>
							</div>
							<div
								class="d-flex justify-content-between align-items-center p-2"
							>
								<div
									class="clearfilter pointer mt-3"
									:class="
										filterselected == null
											? filtercount == 0
												? 'disabled-text'
												: 'pointer'
											: 'pointer'
									"
									@click="clearfilter()"
								>
									Clear Filter
								</div>
								<div>
									<b-button
										class="addbtn"
										:disabled="filterselected == null"
										@click="filter()"
									>
										Apply
									</b-button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="p-1"
					id="config-table"
					:class="
						selectedConfiguration != null
							? 'newconfiguration-table-body'
							: 'noSelected-table-body'
					"
				>
					<template v-if="this.configurations.length > 0">
						<div
							class="newconfiguration-table-row pointer"
							v-for="data in configurations"
							:key="data.configID"
							:class="data.tagged ? 'tagged-class' : ''"
							@click="
								data.open == 'False'
									? expiredconfigModal(data)
									: selectConfig(data)
							"
						>
							<div style="width: 20%">
								<div
									:class="
										data.tagged ? 'selectedColorbar' : 'deselectedColorbar'
									"
								></div>
								<span style="margin-left: 20px">{{ data.configName }} </span>
							</div>
							<div style="width: 30%" class="text-center">
								<span v-if="data.groupNames.length > 0">
									{{ data.groupNames | filterGroupName }}
									<span
										v-if="data.groupNames.length > 1"
										class="configMoreData"
										:id="data.groupNames"
									>
										and {{ data.groupNames.length - 1 }} others</span
									>
								</span>
							</div>
							<div style="width: 10%" class="text-center">
								<span v-if="data.config.closeTestdt != null">
									{{ data.config.openTestdt | datefilter }}
								</span>
								<span v-else> -- </span>
							</div>
							<div style="width: 10%" class="text-center">
								<span v-if="data.config.closeTestdt != null">
									{{ data.config.closeTestdt | datefilter }}
								</span>
								<span v-else> -- </span>
							</div>
							<div style="width: 10%" class="text-center">
								<span v-if="data.config.test != null">
									{{ data.config.test }}
								</span>
								<span v-else> -- </span>
							</div>
							<div style="width: 10%" class="text-center">
								<span v-if="data.open == 'False'" class="expiredClass"
									>Expired</span
								>
								<span v-else class="activetext">Active</span>
							</div>
							<div style="width: 10%" class="text-right">
								<img
									src="../../assets/eyeicon.svg"
									alt=""
									class="mr-3 pointer"
									v-b-tooltip.hover.top="{ variant: 'secondary' }"
									title="View"
									@click.stop="viewConfig(data)"
								/>
								<img
									v-if="roles.includes(roledata.editconfig)"
									src="../../assets/pencilicon.svg"
									alt=""
									class="mr-3 pointer"
									v-b-tooltip.hover.top="{ variant: 'secondary' }"
									title="Edit"
									@click.stop="editConfig(data)"
								/>
								<img
									v-if="roles.includes(roledata.deleteconfig)"
									class="pointer mr-1"
									src="../../assets/deleteicon.svg"
									alt=""
									v-b-tooltip.hover.top="{ variant: 'secondary' }"
									title="Delete"
									@click.stop="configDelete(data.configID)"
								/>
							</div>
						</div>
					</template>
					<template v-else-if="searchTopicTest != ''">
						<div
							class="cl-testcontainer relativeclass mr-2"
							style="height: 97%"
							id="top1"
						>
							<div
								class="d-flex flex-column align-items-center justify-content-center h-100"
							>
								<div>
									<img src="../../assets/searchnotfound.svg" alt="" />
								</div>

								<div class="text-center">
									<span class="searchnotfound"
										>No matching results for
										<span class="searchtext text-break">
											"{{ searchTopicTest }}"
										</span>
										.</span
									>
								</div>
							</div>
						</div>
					</template>
					<template
						v-else-if="
							configurations.length == 0 &&
								!LoaderStatus &&
								searchTopicTest != ' '
						"
					>
						<div class="text-center">
							<img src="../../assets/nodata.svg" alt="No data found" />
						</div>
					</template>
				</div>

				<div
					class="paginaTion d-flex justify-content-between align-items-center"
				>
					<div class="d-flex">
						<span class="qb-gotopage-text p-1">Go to page</span>
						<b-form-input
							type="text"
							class="qb-pagination-num mr-1"
							v-model.trim="goToPage"
							@keyup.enter="
								goToPage === null || goToPage == '' || iscontainsNumber
									? ''
									: goToPages(goToPage)
							"
						></b-form-input>
						<b-button
							:disabled="
								goToPage === null || goToPage == '' || iscontainsNumber
							"
							class="qb-pagination-addbtn"
							@click="goToPages(goToPage)"
						>
							<span><img src="../../assets/whiterightarrow.svg" alt=""/></span>
						</b-button>
					</div>
					<div class="pagination">
						<b-pagination
							v-model.number="currentPage"
							@input="goToPageNum()"
							:total-rows="total"
							:per-page="count"
							align="center"
							first-number
							last-number
						>
							<template #prev-text
								><span><img src="../../assets/leftvector.svg" alt="" /> </span
							></template>
							<template #next-text
								><span><img src="../../assets/rightarrow.svg" alt=""/></span
							></template>
						</b-pagination>
					</div>
					<div class="qb-gotopage-text mr-2">
						Results : <span class="mr-1" v-if="pageStart > total">0</span
						><span class="mr-1" v-else>{{ pageStart }}</span>
						-
						{{ pageEnd }}
						<span class="pl-1"></span> of <span class="pr-1"></span>{{ total }}
					</div>
				</div>
			</div>
		</div>
		<b-modal
			id="modal-delete"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img class="pr-3" src="../../assets/caution.svg" alt="" />
			</div>
			<div @click="$bvModal.hide('modal-delete')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to delete ?</span>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="deleteConfig()">Delete</b-button>
			</div>
		</b-modal>
		<b-modal
			id="configModal"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
			</div>
			<div @click="$bvModal.hide('configModal')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div>
				<div class="mt-3 caution-modal-text">
					<span
						>Are you sure you want to select '{{
							this.selectedConfig.configName
						}}' configuration ?</span
					>
				</div>
				<div>
					<div class="d-flex align-items-center justify-content-end mt-3">
						<b-button class="addbtn mr-3" @click="selectConfigsave()"
							>Select</b-button
						>

						<div
							class="sec-canceltext pointer"
							@click="$bvModal.hide('configModal')"
						>
							Cancel
						</div>
					</div>
				</div>
			</div>
		</b-modal>

		<!-- Expired Configure  modal start -->

		<b-modal
			id="expired-config"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
			</div>
			<div @click="$bvModal.hide('expired-config')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div>
				<div class="expired-config-head mt-3">
					<span> You are selecting an expired configuration. </span>
				</div>

				<div class="expired-config-data mt-3">
					<span>
						You have to edit the start and end date of this configuration to
						continue the selection.
					</span>
				</div>
				<div>
					<div class="d-flex align-items-center justify-content-end mt-3">
						<div
							@click="$bvModal.hide('expired-config')"
							style="width: 15%"
							class="d-flex align-items-center mr-2 pointer cancel-expire-config"
						>
							<span class="cancel-expire-config-text ml-2">Cancel</span>
						</div>

						<b-button
							v-if="roles.includes(roledata.editconfig)"
							class="addbtn mr-3"
							style="border-radius: 5px; width: 20%"
							@click="editExpiredConfig(expiredconfig)"
							>Edit</b-button
						>
					</div>
				</div>
			</div>
		</b-modal>
		<!-- filter modal -->

		<!-- expired configure modal end  -->

		<div class="d-flex justify-content-center">
			<div
				class="alert-box pl-2"
				v-if="
					cautionmodal &&
						configurations.length != 0 &&
						selectedConfiguration == null
				"
			>
				<img src="../../assets/icons/Reports/cautionwhite.svg" alt="" />
				<div v-if="configurations.length != 0" class="caution-text ml-1">
					Please choose a test configuration for the selected individual/group
					by clicking on the existing configuration
				</div>

				<span class="pl-3">
					<img
						style="cursor: pointer"
						src="../../assets/icons/Reports/wrongmark.svg"
						alt=""
						@click="closeCaution()"
					/>
				</span>
			</div>
		</div>
	</div>
</template>
<script>
import {
	postTaggedConfig,
	putShareGroup,
	deleteConfig,
} from "../../utils/apiFunctions";
import toastFunction from "../mixin/toast";
import { mapGetters } from "vuex";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

export default {
	name: "Configure",
	mixins: [toastFunction],
	data() {
		return {
			dataLoaded: false,
			selectedConfigValua: false,
			LoaderStatus: false,
			selectedConfiguration: null,
			showfilter: false,
			filterselected: null,
			storefilter: null,
			filtercount: 0,
			deleteParticular: "",
			view: false,
			expiredconfig: {},
			configurations: [],
			selectedConfig: {},
			grpcontainer: false,
			pageStart: null,
			pageEnd: null,
			total: null,
			totalPages: null,
			count: 10,
			currentPage: 1,
			cautionmodal: true,
			sortOrder: false,
			sorting: false,
			goToPage: null,
			sortColumn: "createdAt",
			groupType: "",
			roledata: {
				addconfig: "",
				editconfig: "",
				deleteconfig: "",
			},
			filteroptions: [
				{
					item: "public",
					name: "Public",
				},
				{
					item: "private",
					name: "Private",
				},
			],
		};
	},
	components: {
		Spinner,
	},
	created() {
		this.LoaderStatus = true;
		this.getConfig();
		if (this.$route.params.testName != undefined) {
			this.setRoleData("auto");
		} else {
			this.setRoleData("config");
		}
	},

	filters: {
		filterGroupName: function(value) {
			if (value.length <= 1) {
				return value.slice(0, 1) + " ";
			} else {
				return value.slice(0, 1) + "";
			}
		},
	},
	watch: {
		searchTopicTest(newValue, oldValue) {
			if (newValue != oldValue) {
				this.currentPage = 1;
				this.LoaderStatus = true;
				this.getConfig();
			}
		},
	},
	computed: {
		...mapGetters("searchVUEX", {
			searchTopicTest: "getSearchTopicTest",
		}),
		// To check if it does not contain an alphabet or zero
		iscontainsNumber() {
			return /^[1-9]\d*$/.test(this.goToPage);
		},
		...mapGetters(["roles"]),
	},
	methods: {
		setRoleData(type) {
			//set roles according to the type of config
			if (type == "auto") {
				this.roledata.addconfig = "PUSH_AUTO_TEST_CONFIG";
				this.roledata.editconfig = "PUT_AUTO_TEST_CONFIG";
				this.roledata.deleteconfig = "DELETE_AUTO_TEST_CONFIG";
			} else {
				this.roledata.addconfig = "PUSH_TEST_CONFIG";
				this.roledata.editconfig = "PUT_TEST_CONFIG";
				this.roledata.deleteconfig = "DELETE_TEST_CONFIG";
			}
		},
		editExpiredConfig(data) {
			if (this.$route.name == "ConfigureAutogenerate") {
				this.$router.push({
					name: "EditConfigurationAutogenerate",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						status: "testTime",
						autoqp: this.$route.query.autoqp,
					},
				});
			} else if (this.$route.name == "ConfigureAutoQPBuilder") {
				this.$router.push({
					name: "EditConfigurationAutoQPBuilder",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						status: "testTime",
						autoqp: this.$route.query.autoqp,
					},
				});
			} else if (this.$route.name == "Configure") {
				this.$router.push({
					name: "EditConfiguration",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						status: "testTime",
						testqp: this.$route.query.testqp,
					},
				});
			} else if (this.$route.name == "configuresandbox") {
				this.$router.push({
					name: "editconfigsandbox",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						testqp: this.$route.query.testqp,
						type: this.$route.query.type,
					},
				});
			} else {
				this.$router.push({
					name: "EditConfigurationTest",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						groupType: this.$route.params.groupType,
					},

					query: {
						configID: data.configID,
						status: "testTime",
						testqp: this.$route.query.testqp,
					},
				});
			}
		},
		expiredconfigModal(data) {
			this.$bvModal.show("expired-config");
			this.expiredconfig = data;
		},
		closeCaution() {
			this.cautionmodal = false;
		},
		goToGroupShare() {
			if (
				this.$route.name == "ConfigureTest" ||
				this.$route.name == "Configure"
			) {
				this.$router.push({
					path: `/sharewithpeople/${this.$route.params.topicID}/${this.$route.params.testID}`,
					query: {
						testqp: this.$route.query.testqp,
						groupType: this.$route.params.groupType,
					},
				});
			} else if (this.$route.name == "ConfigureAutogenerate") {
				this.$router.push({
					// path: `/autogenerate/sharewithpeople/${this.$route.params.topicID}/${this.$route.params.testID}/${this.$route.params.testName}`
					name: "ShareWithPeopleAutogenerate",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
					},
					query: {
						autoqp: this.$route.query.autoqp,
						groupType: this.$route.params.groupType,
					},
				});
			} else if (this.$route.name == "ConfigureAutoQPBuilder") {
				this.$router.push({
					// path: `/qp/sharewithpeople/${this.$route.params.topicID}/${this.$route.params.testID}/${this.$route.params.testName}`
					name: "ShareWithPeopleAutoQPBuilder",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
					},
					query: {
						autoqp: this.$route.query.autoqp,
						groupType: this.$route.params.groupType,
					},
				});
			} else if (this.$route.name == "configuresandbox") {
				this.$router.push({
					name: "sharesandbox",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
					},
					query: {
						testqp: this.$route.query.testqp,
						groupType: this.$route.params.groupType,
						type: this.$route.query.type,
					},
				});
			} else {
				const queryParams = {
					groupType: this.$route.params.groupType,
					testqp: this.$route.query.testqp,
					autoqp: this.$route.query.autoqp,
				};

				Object.keys(queryParams).forEach(
					(key) => queryParams[key] === undefined && delete queryParams[key]
				);

				const routePath = `/share/sharewithpeople/${this.$route.params.topicID}/${this.$route.params.testID}`;

				if (Object.keys(queryParams).length > 1) {
					this.$router.push({
						path: routePath,
						query: queryParams,
					});
				}
			}
		},
		async getConfig() {
			try {
				this.LoaderStatus = true;
				let payload = {
					page: this.currentPage - 1,
					count: this.count,
					sortBy: {
						column: this.sortColumn,
						order: this.sortOrder,
					},
					filters: {
						testType: this.filterselected,
					},

					searchQuery: this.searchTopicTest,
					testID: this.$route.params.testID,
					groupID: this.$route.params.groupID,
				};
				if (this.$route.query.type == "4") {
					Object.assign(payload, {
						sandbox: true,
					});
				}
				if (payload.sortBy.column == null) {
					delete payload.sortBy;
				}
				if (
					payload.filters.testType == null ||
					payload.filters.testType == ""
				) {
					delete payload.filters;
				}
				if (payload.searchQuery == "") {
					delete payload.searchQuery;
				}

				const res = await postTaggedConfig(payload);
				this.dataLoaded = true;
				if (res.status == 200) {
					this.configurations = res.data.data.data;
					this.selectedConfiguration = res.data.data.selectedConfig;
					this.LoaderStatus = false;
				}
				this.pageEnd = res.data.data.pageEnd;
				this.pageStart = res.data.data.pageStart;
				this.total = res.data.data.total;
				this.totalPages = Math.ceil(
					parseInt(this.total) / parseInt(this.count)
				);
				this.$nextTick(() => {
					const element = document.getElementById("config-table");
					element.scrollTo({
						top: 0,
						behavior: "smooth",
					});
				});
			} catch (error) {
				this.LoaderStatus = false;
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		goToPages(index) {
			this.currentPage = Math.min(Math.max(1, index), this.totalPages);
			this.goToPage = null;
			this.getConfig();
		},
		goToPageNum() {
			this.getConfig();
		},
		sort(data) {
			this.sortColumn = data;
			this.sortOrder = !this.sortOrder;
			this.getConfig();
		},
		goback() {
			this.$router.go(-1);
		},
		openfilter() {
			this.showfilter = !this.showfilter;
			this.filterselected = this.storefilter;
		},
		hideDropdown() {
			this.showfilter = false;
		},
		closefilter() {
			this.showfilter = false;
			if (this.filtercount == 0) {
				this.filterselected = null;
			}
		},
		filter() {
			this.filtercount = 1;
			this.storefilter = this.filterselected;
			this.getConfig();
			this.hideDropdown();
		},
		clearfilter() {
			if (this.filtercount == 1) {
				this.filtercount = 0;
				this.filterselected = null;
				this.storefilter = null;
				this.getConfig();
				this.hideDropdown();
			} else {
				this.filterselected = null;
			}
		},
		async selectConfig(data) {
			this.$bvModal.show("configModal");
			this.selectedConfig = data;
		},
		async selectConfigsave() {
			try {
				let payload = {
					testID: this.$route.params.testID,
					groupID: this.$route.params.groupID,
					configID: this.selectedConfig.configID,
				};
				const res = await putShareGroup(payload);
				if (res.status == 200) {
					this.$bvModal.hide("configModal");
					this.successToast("Configuration tagged successfully");
					this.getConfig();
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		addConfiguration() {
			if (this.$route.name == "ConfigureTest") {
				this.$router.push({
					path: `/addconfigure/${this.$route.params.testID}/${this.$route.params.groupID}/${this.$route.params.topicID}/${this.$route.params.groupType}`,
					testqp: this.$route.query.testqp,
				});
			} else if (this.$route.name == "ConfigureAutogenerate") {
				this.$router.push({
					name: "ParticularTestConfigurationAutogenerate",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
						groupType: this.$route.params.groupType,
					},
					query: {
						autoqp: this.$route.query.autoqp,
					},
				});
			} else if (this.$route.name == "ConfigureAutoQPBuilder") {
				this.$router.push({
					name: "ParticularTestConfigurationAutoQPBuilder",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
						groupType: this.$route.params.groupType,
					},
					query: {
						autoqp: this.$route.query.autoqp,
					},
				});
			} else if (this.$route.name == "configuresandbox") {
				this.$router.push({
					name: "addconfigsandbox",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						groupType: this.$route.params.groupType,
					},
					query: {
						testqp: this.$route.query.testqp,
						type: this.$route.query.type,
					},
				});
			} else {
				this.$router.push({
					name: "ParticularTestConfiguration",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						groupType: this.$route.params.groupType,
					},
					query: {
						testqp: this.$route.query.testqp,
					},
				});
			}
		},
		configDelete(data) {
			this.$bvModal.show("modal-delete");
			this.deleteParticular = data;
		},
		async deleteConfig() {
			try {
				this.LoaderStatus = true;
				const res = await deleteConfig(this.deleteParticular);
				if (res.status == 200) {
					this.successToast("Configuration deleted successfully");
					this.$bvModal.hide("modal-delete");
					setTimeout(() => {
						this.getConfig();
					}, 1000);
				} else if (res.status == 409) {
					this.errorToast(
						"There are individuals/groups tagged to this config."
					);
					this.$bvModal.hide("modal-delete");
				} else {
					this.errorToast("Something went wrong");
				}
				this.LoaderStatus = false;
			} catch (error) {
				this.LoaderStatus = false;

				this.$bvModal.hide("modal-delete");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		async editConfig(data) {
			if (this.$route.name == "ConfigureAutogenerate") {
				this.$router.push({
					name: "EditConfigurationAutogenerate",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						autoqp: this.$route.query.autoqp,
					},
				});
			} else if (this.$route.name == "ConfigureAutoQPBuilder") {
				this.$router.push({
					name: "EditConfigurationAutoQPBuilder",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						autoqp: this.$route.query.autoqp,
					},
				});
			} else if (this.$route.name == "Configure") {
				this.$router.push({
					name: "EditConfiguration",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						testqp: this.$route.query.testqp,
					},
				});
			} else if (this.$route.name == "configuresandbox") {
				this.$router.push({
					name: "editconfigsandbox",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						testqp: this.$route.query.testqp,
						type: this.$route.query.type,
					},
				});
			} else {
				this.$router.push({
					name: "EditConfigurationTest",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						groupType: this.$route.params.groupType,
					},

					query: {
						configID: data.configID,
						testqp: this.$route.query.testqp,
					},
				});
			}
		},
		async viewConfig(data) {
			if (this.$route.name == "ConfigureAutogenerate") {
				this.$router.push({
					name: "ViewConfigurationAutogenerate",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						autoqp: this.$route.query.autoqp,
					},
				});
			} else if (this.$route.name == "ConfigureAutoQPBuilder") {
				this.$router.push({
					name: "ViewConfigurationAutoQPBuilder",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						autoqp: this.$route.query.autoqp,
					},
				});
			} else if (this.$route.name == "Configure") {
				this.$router.push({
					name: "ViewConfiguration",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						testqp: this.$route.query.testqp,
					},
				});
			} else if (this.$route.name == "configuresandbox") {
				this.$router.push({
					name: "viewconfigsandbox",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						testqp: this.$route.query.testqp,
						type: this.$route.query.type,
					},
				});
			} else {
				this.$router.push({
					name: "ViewConfigurationTest",
					params: {
						testID: this.$route.params.testID,
						groupID: this.$route.params.groupID,
						topicID: this.$route.params.topicID,
						groupType: this.$route.params.groupType,
					},
					query: {
						configID: data.configID,
						testqp: this.$route.query.testqp,
					},
				});
			}
		},
	},
};
</script>
<style>
.expired-config-head {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	line-height: 21px;
	color: #545454;
}

.expired-config-data {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 21px;

	color: #696969;
}

.select-config-head {
	background: #ccfacb;
	border-radius: 3px;
	padding: 2px 20px;
	position: absolute;
	left: 20px;
	top: -10px;
}

.select-config-head-font {
	font-weight: 400;
	font-size: 12px;
	line-height: 18px;
	color: #038e00;
}

.new-slectedcandidate-table-container {
	height: calc(100vh - 250px);
	background: #ffffff;
	border-radius: 8px;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 100%;
}

.select-configurations-head {
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
}

.select-configurations-subhead {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.config-dynamicGrid {
	width: 4px;
	height: 75px;
	border-radius: 5px;
	position: absolute;
	left: 4px;
	background-color: #4ef085;
}

.table-body {
	position: relative;
}

.alert-box {
	position: absolute;
	padding: 5px;
	bottom: 62px;
	display: flex;
	align-items: center;
	background: #5782ff;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
}

.cancel-expire-config {
	border: 1px solid #72738e;
	border-radius: 3px;
	padding: 5px;
}

.cancel-expire-config-text {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
}

.caution-text {
	color: #ffffff;
}

.twobtns {
	position: absolute;
	bottom: 10px;
	right: 20px;
}

.cancelbtntext {
	font-weight: 600;
	font-size: 13px;
	color: #72738e;
}

.deliveredtext {
	font-weight: 500;
	font-size: 13px;
	color: #ad1927;
}

.activetext {
	font-weight: 500;
	font-size: 13px;
	color: #18a41d;
}

.normaltext {
	color: #696969;
	font-weight: 500;
	font-size: 13px;
}

.slectedcandidate-table-container {
	background: #ffffff;
	border-radius: 8px;
	height: calc(100vh - 155px);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 100%;
}

.grp-right-container {
	background: #ffffff;
	border-radius: 8px;
	height: calc(100vh - 155px);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 30%;
}

.slectedcandidate-table-container-seventy {
	background: #ffffff;
	border-radius: 8px;
	height: calc(100vh - 155px);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 70%;
}

.config-reports-table thead tr {
	height: 45px;
	background: #72738e;
	border-radius: 3px;
	vertical-align: middle;
	display: table;
	width: 100%;
	table-layout: fixed;
}

.config-reports-table thead th {
	font-weight: 500 !important;
	font-size: 14px;
	color: white;
}

.config-reports-table thead th:last-child {
	padding-right: 15px;
}

.config-reports-table tbody td {
	font-style: normal;
	font-weight: normal;
	font-size: 13px;
	color: #696969;
	overflow: hidden;
	text-overflow: ellipsis;
}

.config-reports-table tbody td:first-child {
	position: relative;
}

.config-reports-table tbody td:last-child {
	padding-right: 20px;
}

.config-reports-table tbody tr {
	height: 60px;
	cursor: pointer;
	border: 0.5px solid #e5e5e5;
	box-sizing: border-box;
	background: #fcfcfc;
	box-shadow: 0px 4px 12px rgb(196 196 196 / 50%);
	margin: 10px 5px 8px 5px;
	width: calc(100% - 10px);
	display: table;
	border-radius: 3px;
	table-layout: fixed;
}

.shareppl-parentdiv {
	position: relative;
	height: calc(100vh - 90px);
	top: 80px;
	padding-left: 80px;
	overflow-y: auto;
	overflow-x: hidden;
	padding-right: 15px;
}

.selected-table-cards:hover {
	background: #e7e8f5;
}

.shareview-details {
	background: #f5f5f5;
}

.shareview-details-bold {
	font-size: 12px;
	color: #696969;
	font-weight: var(--weight-LM);
}

.shareview-details-text {
	font-size: 12px;
	color: #696969;
	font-weight: var(--weight-R);
}

.shareview-details-email {
	font-size: 12px;
	color: #696969;
	font-weight: var(--weight-M);
}

.selectedCandidateContainer {
	height: 389px;
	overflow-y: auto;
}

.groupshare-formtag {
	border: none;
	padding: 0px;
}

.groupshare-seachinput {
	padding: 0.5rem 2rem !important;
}

.selectedColorbar {
	width: 4px;
	background: #4ef085;
	border-radius: 2px;
	position: absolute;
	height: 90%;
	top: 2.5px;
}

.deselectedColorbar {
	width: 4px;
	background: #ff4752;
	border-radius: 2px;
	position: absolute;
	height: 90%;
	top: 2.5px;
}

.configMoreData {
	color: #72738e;
	font-weight: var(--weight-LM);
}

.newGrouptable tbody {
	display: block;
	border-radius: 5px;
	overflow: auto;
	height: calc(100vh - 350px);
	margin-top: 5px;
	width: calc(100% - 5px);
}

.newGroupTable-two tbody {
	height: calc(100vh - 250px);
	display: block;
	border-radius: 5px;
	overflow: auto;
	margin-top: 5px;
	width: calc(100% - 5px);
}

.tagged-class {
	background: #dee2e6 !important;
}

/* configure new table design starts from here  */
.noSelectedConfiguration-main-table {
	width: 100%;
	position: relative;
	height: calc(100vh - 163px);
	overflow-x: auto;
	overflow-y: hidden;
	background: #ffffff;
	border-radius: 8px;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
}

.newconfiguration-main-table {
	width: 100%;
	position: relative;
	height: calc(100vh - 250px);
	overflow-x: auto;
	overflow-y: hidden;
	background: #ffffff;
	border-radius: 8px;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
}

.newSelected-main-table {
	height: calc(100vh - 155px);
	width: 100%;
	position: relative;
	overflow-x: auto;
	overflow-y: hidden;
	background: #ffffff;
	border-radius: 8px;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
}

.newconfiguration-table-head {
	min-width: 1000px;
	max-width: 100%;
	background-color: #72738e;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 10px 0px;
	color: #fff;
	font-size: 14px;
	font-weight: 500;
}

.select-configurations {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 20px;
}

.newconfiguration-table-body {
	min-width: 1000px;
	max-width: 100%;
	overflow-y: auto;
	height: calc(100vh - 336px);
}

.noSelected-table-body {
	min-width: 1000px;
	max-width: 100%;
	overflow-y: auto;
	height: calc(100vh - 245px);
}

.newconfiguration-table-row {
	width: 100%;
	position: relative;
	border-radius: 3px;
	border: 0.5px solid #e5e5e5;
	background: #fafafa;
	box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 13px;
	color: #696969;
	padding: 20px 5px;
	margin: 10px 0px;
}

.newconfiguration-table-row:hover {
	background: #e7e8f5;
}

.paginaTion {
	min-width: 1002px;
	max-width: 100%;
	padding: 5px 10px;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}

.sharepeople-filter-modal-config {
	position: absolute;
	width: 365px;
	height: 150px;
	top: 34px;
	right: 34px;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
	border-radius: 5px;
	z-index: 6;
}

.qb-filter-count-config {
	width: 15px;
	background: #ff7e47;
	border-radius: 10px;
	height: 15px;
	font-weight: var(--weight-B);
	font-size: var(--size-10);
	padding-top: 2px;
	padding-left: 7px;
	position: absolute;
	top: 3px;
	right: 10px;
}
</style>
